<template>
  <Header :style="{ position: 'absolute', top: 0, width: '100%', minWidth: '1024px' }">
    <!-- logo -->
    <div :class="[!isCollapsed ? 'logo-large-icon' : 'logo-small-icon']">
      <img v-show="!isCollapsed" key="max-logo" :src="maxLogo" />
      <img v-show="isCollapsed" key="min-logo" :src="minLogo" />
    </div>
    <!-- navbar -->
    <div :class="[!isCollapsed ? 'navbar' : 'navbar-toggle']">
      <span @click="collapsedSider">
        <Icon class="toggle-tap" type="md-menu" size="18" />
      </span>
      <!-- <router-link v-if="userType" to="/informationCenter/dataAnalytics" tag="span" :class="router.indexOf('informationCenter') > -1 ? 'active' : ''">情报中心</router-link> -->
      <router-link v-if="userType" to="/knowledgeGraph" tag="span" :class="router.indexOf('knowledgeGraph') > -1 ? 'active' : ''">知识图谱</router-link>
      <router-link v-if="userType" to="/relationalGraph" tag="span" :class="router.indexOf('relationalGraph') > -1 ? 'active' : ''">关系图谱</router-link>
      <!-- <router-link v-if="userType" to="/infringementMap" tag="span" :class="router.indexOf('infringementMap') > -1 ? 'active' : ''">侵权地图</router-link> -->
      <router-link v-if="userType" to="/industryAnalysis" tag="span" :class="router.indexOf('industryAnalysis') > -1 ? 'active' : ''">行业分析报告</router-link>
      <router-link to="/evidenceCenter/dataAnalytics" tag="span" :class="router.indexOf('evidenceCenter') > -1 ? 'active' : ''">证据中心</router-link>
      <router-link v-if="userType" to="/systemCenter/userAdmin" tag="span" :class="router.indexOf('systemCenter') > -1 ? 'active' : ''">系统管理</router-link>
    </div>
    <!-- 个人中心 -->
    <div class="header-right">
      <span :class="[infoCtrl?'active':'','head-img-box']" @click="hideOrShow">
        <img :src="avatarSrc" alt="" :title="name">
        <Card v-show="infoCtrl" class="more-router" :padding="0">
          <Col class="info-box">
            <img class="head-img" :src="avatarSrc">
            <p>{{ name }}</p>
          <!-- <p class="small-p">开发人员特派律师事务所</p> -->
          </Col>
          <Col class="info-btn-box">
            <!--            <Button disabled>个人中心</Button>-->
            <!-- <Button>修改密码</Button> -->
            <Button @click="logout">退出</Button>
          </Col>
        </Card>
      </span>
    </div>
  </Header>
</template>
<script>
// import userLogo from '@/assets/images/card-02.png'
export default {
  components: {},
  props: [''],
  data() {
    const newPasswordValid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入确认密码'))
      }
      if (value !== this.formItem.password) {
        return callback(new Error('两次密码不一致'))
      }
      callback()
    }
    return {
      name: '',
      companyName: '',
      isCollapsed: false,
      taskCtrl: false,
      noticeCtrl: false,
      maxLogo: require('./../../assets/images/logo-lawyer.png'),
      minLogo: require('./../../assets/images/logo-small.png'),
      avatarSrc: require('@/assets/images/portrait.png'),
      loadingText: '加载中',
      langStr: '中文',
      currentTeam: '律师团队',
      infoCtrl: false,
      // src: userLogo,
      changeCtrl: false,
      isSubmit: false,
      userType: false,
      formItem: {
        oldPassword: '',
        newPassword: '',
        password: ''
      },
      formItemRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        newPassword: [{ required: true, validator: newPasswordValid, trigger: 'blur' }]
      }
    }
  },
  computed: {
    router() {
      this.getMenu(this.$route.path)
      return this.$route.path
    }
  },
  watch: {
    router(val, oldVal) {
      this.getMenu(val)
    },
    changeCtrl(val, oldVal) {
      if (!val) {
        for (const key in this.formItem) {
          this.formItem[key] = ''
        }
      }
    }
  },
  created() {
  },
  beforeMount() { },
  mounted() {
    document.addEventListener('click', e => {
      if (!this.$el.contains(e.target)) {
        this.taskCtrl = false
        this.noticeCtrl = false
        this.infoCtrl = false
      }
    })
    this.name = window.localStorage.getItem('name')
    this.userType = window.localStorage.getItem('userType') === 'true'
    console.log('1111111', this.userType)
    console.log('1111111', this.userType)
  },
  updated() { },
  methods: {
    logout() {
      const url = '/intelligence-service/system/account/logout'
      this.$post(url).then(res => {
        if (res.code === 0) {
          this.$router.push({ path: '/login' })
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    hideOrShow() {
      this.infoCtrl = !this.infoCtrl
    },
    collapsedSider() {
      this.isCollapsed = !this.isCollapsed
      this.$store.commit('toggleCollapsed', this.isCollapsed)
    },
    // 控制路由
    getMenu(val) {
      let activeMenus = []
      switch (true) {
        case val.indexOf('informationCenter') > -1:
          activeMenus = this.menu.informationList
          break
        case val.indexOf('knowledgeGraph') > -1:
          activeMenus = this.menu.knowledgeGraph
          break
        case val.indexOf('evidenceCenter') > -1:
          activeMenus = this.menu.evidenceList
          break
        case val.indexOf('systemCenter') > -1:
          activeMenus = this.menu.systemCenter
          break
      }
      console.log(activeMenus)
      this.$store.commit('changeMenu', activeMenus)
    }
  }
}
</script>
<style lang="sass" scoped>
@import './header.scss'
</style>
<style lang="scss">
.notice-tips .ivu-cell-arrow {
  right: 5px;
}

.notice-tips .ivu-cell-title {
  line-height: normal;
}

.ivu-cell-title {
  line-height: 24px;
  font-size: 14px;
}

.notice-tips:last-child {
  border: none;
}

.more-router {
  .ivu-card-head {
    padding: 7px 10px;
  }

  .ivu-scroll-loader:first-child {
    display: none;
  }

  .ivu-spin-text {
    i {
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue